import keysManagement from './keysManagement'
import settings from './settings'
import format from './format'
import notifications from './notifications'
export default {
  keysManagement,
  settings,
  format,
  notifications
}
